class SalutWishlistPage extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('[data-wishlist-grid]');
    this.empty = this.querySelector('[data-wishlist-empty]');
    this.status = this.querySelector('[data-wishlist-status]');
    this.skeleton = this.querySelector('[data-wishlist-skeleton]');
    this.counter = this.querySelector('[data-wishlist-count]');
    this.cards = new Map();
    this.busy = false;
    this.queued = false;
    this.render = this.render.bind(this);
  }

  connectedCallback() {
    if (!window.SalutWishlist) {
      this.empty.hidden = false;
      return;
    }

    document.addEventListener(window.SalutWishlist.changeEvent, this.render);
    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener(window.SalutWishlist.changeEvent, this.render);
  }

  get handles() {
    return window.SalutWishlist ? window.SalutWishlist.get() : [];
  }

  async render() {
    if (this.busy) {
      this.queued = true;
      return;
    }

    this.busy = true;

    const handles = this.handles;

    this.cards.forEach((card, handle) => {
      if (handles.includes(handle)) return;
      card.remove();
      this.cards.delete(handle);
    });

    const missing = handles.filter((handle) => !this.cards.has(handle));

    if (missing.length) {
      this.showSkeletons(missing.length);
      const fetched = await Promise.all(missing.map((handle) => this.fetchCard(handle)));
      this.hideSkeletons();

      const gone = missing.filter((handle, index) => fetched[index] === null);
      if (gone.length) {
        gone.forEach((handle) => this.cards.delete(handle));
        this.busy = false;
        gone.forEach((handle) => window.SalutWishlist.remove(handle));
        return;
      }
    }

    handles.forEach((handle) => {
      const card = this.cards.get(handle);
      if (card) this.grid.appendChild(card);
    });

    const total = this.cards.size;
    this.counter.textContent = total;
    this.counter.hidden = total === 0;
    this.empty.hidden = total > 0;
    window.SalutWishlist.sync(this);

    this.busy = false;

    if (this.queued) {
      this.queued = false;
      this.render();
    }
  }

  showSkeletons(count) {
    if (!this.skeleton) return;

    this.hideSkeletons();

    const fragment = document.createDocumentFragment();
    for (let index = 0; index < count; index += 1) {
      fragment.appendChild(this.skeleton.content.cloneNode(true));
    }

    this.grid.appendChild(fragment);
    this.grid.setAttribute('aria-busy', 'true');
    if (this.status) this.status.textContent = this.status.dataset.loadingText;
  }

  hideSkeletons() {
    this.grid.querySelectorAll('.wishlist-salut__item--skeleton').forEach((item) => item.remove());
    this.grid.removeAttribute('aria-busy');
    if (this.status) this.status.textContent = '';
  }

  async fetchCard(handle) {
    try {
      const response = await fetch(this.dataset.cardUrl.replace('__handle__', encodeURIComponent(handle)));
      if (!response.ok) return null;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = html.querySelector('.product-card-salut');
      if (!card) return null;

      const item = document.createElement('li');
      item.className = 'wishlist-salut__item';
      item.dataset.handle = handle;
      item.appendChild(card);
      this.cards.set(handle, item);
      return item;
    } catch {
      return null;
    }
  }
}

customElements.define('salut-wishlist-page', SalutWishlistPage);
